import my_logo from '../assets/logo.png'

function Header({ title }) {
    return (
        <div className="sub-sec-tab-console new-tab-console">
            <div className="tab-bar">
                <div className="tab-name">
                    <img id='my-logo' src={my_logo} alt='' />
                    <div id='tab-title'>{title}</div>
                </div>
                <div className="tab-options">
                    <img className='tab-icon' src="https://img.icons8.com/fluency-systems-filled/96/FFFFFF/compress--v1.png" alt='' />
                    <img className='tab-icon' src="https://img.icons8.com/fluency-systems-filled/96/FFFFFF/full-screen.png" alt='' />
                    <img className='tab-icon' src="https://img.icons8.com/fluency-systems-filled/96/FFFFFF/delete-sign.png" alt='' />
                </div>
            </div>
            <div className="console-content">
                <div className="prompt">stormsalpha:\&gt; cd {title.toLowerCase()}/</div>
                <div className="prompt">stormsalpha:\{title.toLowerCase()}&gt; ls</div>
            </div>
        </div>
    );
}

export default Header;